// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// This uses BaseSuperAdminFactory instead of class inheritance

import { createBaseSuperAdmin, type IBaseSuperAdmin } from "../BaseSuperAdminFactory";
import type { Office } from "le-coffre-resources/dist/SuperAdmin";
import type { QueryPayload } from "../../../types";
import type { IGetOfficesparams } from "./Offices";

interface OfficesInstance {
	get(q?: IGetOfficesparams): Promise<Office[]>;
	getByUid(uid: string, q?: QueryPayload): Promise<Office>;
}

// Module-level singleton instance
let instance: OfficesInstance | null = null;
let baseSuperAdminInstance: IBaseSuperAdmin | null = null;

function createOffices(): OfficesInstance {
	if (!baseSuperAdminInstance) {
		baseSuperAdminInstance = createBaseSuperAdmin();
	}

	const baseSuperAdmin = baseSuperAdminInstance;
	const baseUrl = baseSuperAdmin.namespaceUrl.concat("/offices");

	return {
		get: async (q?: IGetOfficesparams): Promise<Office[]> => {
			const url = new URL(baseUrl);
			if (q) {
				baseSuperAdmin.appendJsonSearchParams(url, { q });
			}
			try {
				return await baseSuperAdmin.getRequest<Office[]>(url);
			} catch (err) {
				baseSuperAdmin.onError(err);
				return Promise.reject(err);
			}
		},
		getByUid: async (uid: string, q?: QueryPayload): Promise<Office> => {
			const url = new URL(baseUrl.concat(`/${uid}`));
			if (q) baseSuperAdmin.appendJsonSearchParams(url, q);
			try {
				return await baseSuperAdmin.getRequest<Office>(url);
			} catch (err) {
				baseSuperAdmin.onError(err);
				return Promise.reject(err);
			}
		},
	};
}

export function getOfficesInstance(): OfficesInstance {
	if (!instance) {
		instance = createOffices();
	}
	return instance;
}
